import React, { ComponentType, Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";
import { IInsufficientAuthAddressSelectProps } from "./insufficientAuthAddressSelect";

const InsufficientAuthAddressSelect = React.lazy(
  () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "slide-outs" */
      "./insufficientAuthAddressSelect"
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as unknown as Promise<{ default: ComponentType<any> }>
);

export interface IInsufficientAuthAddressSelectWrapperProps
  extends IInsufficientAuthAddressSelectProps {
  fallback: React.ReactElement;
}

const InsufficientAuthAddressSelectWrapper = (
  props: IInsufficientAuthAddressSelectWrapperProps
) => {
  return (
    <>
      {ServerSideService.isServerSide ? undefined : (
        <Suspense fallback={props.fallback}>
          <InsufficientAuthAddressSelect {...props} />
        </Suspense>
      )}
    </>
  );
};

export default InsufficientAuthAddressSelectWrapper;
